import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrSumComponent } from './pr-sum/pr-sum.component';
import { PrSumItemComponent } from './pr-sum-item/pr-sum-item.component';
import { PrIconModule } from '../pr-icon/pr-icon.module';

@NgModule({
  declarations: [PrSumComponent, PrSumItemComponent],
  imports: [CommonModule, PrIconModule],
  exports: [PrSumComponent, PrSumItemComponent],
})
export class PrSumModule {}
